module.exports = __webpack_public_path__ + "img/logo.215b328f.png";